import * as tslib_1 from "tslib";
import { config } from "./config";
import { deepObserve } from "./deep-observe";
import isEqual from "lodash.isequal";
export class SubModel {
}
export class Model {
    constructor(DBInstance) {
        /**------------------------------------------
         *  pouchdb built-in props that we'll use
         *
         */
        this._id = config.UUID();
        /**------------------------------------------
         *  internal props that are specific to pouchx
         *
         */
        // becomes true if no updates should be propagated to pouchdb
        this.__ignoreObserver = false;
        this.__DBInstance = DBInstance;
    }
    saveToPouch() {
        // this is just to expose the method
        // this will actually be overwritten by
        // the method in the decorator below
    }
}
export function observeModel(model) {
    class Local extends model {
        /**------------------------------------------
         *  putting the document (in its current state)
         * in pouchDB
         */
        saveToPouch() {
            return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                this.__next = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    const newDoc = this.toJSON();
                    const oldDoc = yield this.__DBInstance.get(this._id);
                    newDoc._rev = oldDoc._rev;
                    if (isEqual(oldDoc, newDoc)) {
                        // prevent duplicates & conflicts
                        resolve({});
                        return;
                    }
                    const response = yield this.__DBInstance.put(newDoc, {
                        force: true,
                    });
                    this._rev = response.rev;
                    resolve(response);
                    return response;
                });
            }));
        }
        constructor(...args) {
            super(...args);
            deepObserve(this, (change) => {
                // ignore internal changes
                if (change.name &&
                    change.name.toString().startsWith("_")) {
                    return;
                }
                // ignore changes when we're told to ignore them
                if (this.__ignoreObserver) {
                    return;
                }
                this.saveToPouch();
            });
            setInterval(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (this.__next) {
                    const res = yield this.__next();
                    if (res && res.ok) {
                        this.__next = undefined;
                    }
                }
            }), config.queInterval);
        }
    }
    return Local;
}
